import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Microphone = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M8 11.32a3.667 3.667 0 0 1-3.666-3.666V4.321a3.666 3.666 0 0 1 7.333 0v3.333a3.666 3.666 0 0 1-3.666 3.666Zm0-10a3.003 3.003 0 0 0-3 3v3.334a3 3 0 1 0 6 0V4.321a3.003 3.003 0 0 0-3-3ZM11.334 15.987H4.667a.333.333 0 0 1 0-.667h6.667a.333.333 0 1 1 0 .667Z" />
      <path d="M8.001 15.988a.333.333 0 0 1-.333-.334v-2.666a.333.333 0 1 1 .667 0v2.666a.333.333 0 0 1-.334.334Z" />
      <path d="M8 13.32a5.663 5.663 0 0 1-5.666-5.666.333.333 0 1 1 .667 0 5 5 0 1 0 10 0 .333.333 0 1 1 .666 0 5.663 5.663 0 0 1-5.666 5.666ZM6.334 5.32H4.667a.333.333 0 0 1 0-.666h1.667a.333.333 0 1 1 0 .667Z" />
      <path d="M6.334 7.655H4.667a.333.333 0 0 1 0-.667h1.667a.333.333 0 1 1 0 .667ZM11.334 5.32H9.667a.333.333 0 0 1 0-.666h1.667a.333.333 0 1 1 0 .667ZM11.334 7.655H9.667a.333.333 0 0 1 0-.667h1.667a.333.333 0 1 1 0 .667Z" />
    </svg>
  );
};

Microphone.category = 'product-category';

Microphone.displayName = 'Microphone';
